import Resource from '@/api/resource'
import request from '@/utils/request'
import store from '@/store/index'

class Roles extends Resource {
  constructor() {
    super('roles')
  }

  listRoles(query) {
    return request({
      url: `${this.uri}/list_roles`,
      method: 'get',
      data: query,
    })
  }

  put(query) {
    return request({
      url: `/${this.uri}/put_role`,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: query,
    })
  }

  getRole(query) {
    return request({
      url: `/${this.uri}/show_role`,
      method: 'get',
      data: query,
    })
  }

  getUser(query) {
    return request({
      url: `/${this.uri}/user`,
      method: 'get',
      data: query,
    })
  }
}

export { Roles as default }
